// extracted by mini-css-extract-plugin
export var videoContainer = "_k0-0";
export var videoIframe = "_k0-3";
export var videoLink = "_k0-1";
export var videoOverlay = "_k0-4";
export var videoOverlayText = "_k0-5";
export var videoWrapper = "_k0-2";